// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--fill: currentColor}:host{--fill: currentColor;display:inline-block;width:1em;height:1em;vertical-align:middle}:host(:not([preserve])) svg *{fill:var(--fill, currentColor) !important;transition:200ms fill}svg{display:block;width:inherit !important;height:inherit !important}:host([absolute-position])>svg{width:100% !important;height:100% !important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
